import BrandComponents from "../../Masters/Brand/BrandComponents";

function OpeningStockList() {
  let header = [
    { label: "Id", field: "id" },
    { label: "warehousename", field: "warehousename" },
    { label: "productname", field: "productname" },
    { label: "quantity", field: "quantity" },
    { label: "openingdate", field: "openingdate" },

  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"OPENING STOCK LIST"}
        apiField={"openingstock"}
        addButton={"+ ADD"}
        createRoute={"/opening-stock-add"}
        updateRoute={"/opening-stock-update"}
        viewRoute={"/opening-stock-update"}
      />
    </div>
  );
}

export default OpeningStockList;